<template>
  <div class="top-left w50 right margin margin_l_hf margin_r_c">
    <div class="styleCard">
      <!--      <div class="styleCardContent sysChat padding">-->
      <div v-if="chartsViewBlocks[2] !== 'questions' && chartsViewBlocks[2] !== 'keyword' && chartsViewBlocks[2] !== 'location'" class="menu-wrapper">
        <ul class="sub-menu-dropup">
          <li
            class="dropdown-item btn btn-block btn-light-gray"
            v-for="tab in subMenu"
            :key="tab"
            :class="{
              active: selectedTab === tab.alias.toUpperCase()
            }"
            @click="setClickFromMenu(tab.alias.toUpperCase())"
          >
            <span>
              <i class="fas fa-caret-left"></i>
            </span>
            <span class="tabName"> {{ tab.name }}</span>
          </li>
        </ul>
      </div>
      <div class="sysChatContentTemp">
        <live-stats-chart
          v-if="
            $route.name === 'Main' &&
              (chartsViewBlocks[2] === null || chartsViewBlocks[2] === 'LIVE')
          "
        />


        <div v-if=" $route.name === 'Main' &&
              chartsViewBlocks[2] === 'AKG' &&
              matrixView"
             v-click-outside="closeMatrix"
        >
          <matrix-view-component
              @matrix="closeMatrix"
              :matrix-view="matrixView"
              :main-sector="'MAIN'"
              :sub-sector="'AKG'"
          />
        </div>
        <questions-charts
          v-if="mainView === 'questions'"
          :main-sector="mainView"
          :main-data="multiSelectChartData"
        />
        <CampaignsChartsKeyword
          v-if="mainView === 'keyword'"
          :main-sector="mainView"
          :main-data="multiSelectChartData"
        />

        <CampaignsChartsLocation
            v-if="mainView === 'location'"
            :main-sector="mainView"
            :main-data="multiSelectChartData"
        />
        <div
          v-if="
            CheckUserPermission([1, 2, 3, 4, 7, 12]) &&
              chartsViewBlocks[2] === 'Y-ST-CM' &&
              selectedTab === 'Y-ST-CM'
          "
        >
          <daily-stats-comparison-reports />
        </div>

        <div
          class="styleCardContent padding"
          v-if="
            CheckUserPermission([1, 2, 3, 4, 12]) &&
              chartsViewBlocks[2] === 'Y-STATS' &&
              selectedTab === 'Y-STATS'
          "
        >
          <daily-stats-reports></daily-stats-reports>
        </div>

        <div
          class="styleCardContent padding"
          v-if="
            CheckUserPermission([1, 2, 3, 4, 12]) &&
              chartsViewBlocks[2] === 'REP' &&
              selectedTab === 'REP'
          "
        >
          <StatsReports />
        </div>
      </div>
      <!--      </div>-->
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import apiClientCreator from "../../../../../helpers/api/request";
import moment from "moment";
import { Globals } from "../../../../../global_constants/constants";
import UsersPermissionCheck from "../../../../../mixins/user/auth/UsersPermissionCheck";
import LiveStatsChart from "../components/GeneralLiveStatsChart.component";
import QuestionsCharts from "../components/block_2/QuestionsCharts.component";
import DailyStatsReports from "../../../../../features/statistics.feature/live_stats.sub_feature/components/DailyStatsReports.component";
import underPerfCrCharts from "../../../../company.feature/sub_features.company/graph.sub-feature.company/components/viki_chart/underPerfCrCharts.component";
import RetentionsCharts from "../../../../company.feature/sub_features.company/graph.sub-feature.company/components/viki_chart/RetentionsCharts.component";
import DailyStatsComparisonReports from "../../../../../features/statistics.feature/live_stats.sub_feature/components/DailyStatsComparisonReports.component";
import StatsReports from "../../../../statistics.feature/live_stats.sub_feature/components/StatsReports.container";
import CampaignsChartsKeyword from "../components/block_2/CampaignsChartsKeyword.component";
import CampaignsChartsLocation from "../components/block_4/CampaignsChartsLocation.component";
import MatrixViewComponent from "../../../../company.feature/sub_features.company/graph.sub-feature.company/components/matrix_view/MatrixViewComponent";


export default {
  name: "RightMainChart.container",
  components: {
    MatrixViewComponent,
   /// CampaignsChartsPlacement,
    CampaignsChartsLocation,
    CampaignsChartsKeyword,
    LiveStatsChart,
    QuestionsCharts,
    DailyStatsComparisonReports,
    DailyStatsReports,
    StatsReports,
    /*    underPerfCrCharts,
    RetentionsCharts*/
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapGetters("clients", ["loading"]),
    ...mapGetters("main", ["showVikiMsg"]),
    ...mapState("main", ["showVikiMsg"]),
    ...mapState("clients", [
      "dictionaries",
      "salesPersonList",
      "loading",
      "chartsViewBlocks",
      "multiSelectChartData"
    ])
  },
  mixins: [UsersPermissionCheck],
  data() {
    return {
      matrixView:false,
      mainView: null,
      blockNumber: 2,
      subMenu: [
        {
          id: 1,
          alias: "LIVE",
          name: "LIVE",
          default: true
        },
        {
          id: 5,
          alias: "AKG",
          name: "AKG",
          default: false
        },
        {
          id: 2,
          alias: "Y-ST-CM",
          name: "Y-ST-CM",
          default: false
        },
        {
          id: 3,
          alias: "Y-STATS",
          name: "Y-STATS",
          default: false
        },
        {
          id: 4,
          alias: "REP",
          name: "REP",
          default: false
        }
      ],
      selectedTab: "LIVE"
    };
  },
  mounted() {},

  watch: {
    chartsViewBlocks: function() {
      this.mainView = this.chartsViewBlocks[this.blockNumber];
    }
  },

  methods: {
    closeMatrix() {
      this.matrixView = false;
    },
    setClickFromMenu(tab) {
      if(tab === 'AKG'){
        this.matrixView = true
      }
      let tempObj = Object.assign({}, this.chartsViewBlocks);
      tempObj[2] = tab;
      this.$store.commit("clients/setChartsViewBlocks", tempObj);
      this.selectedTab = tab;
    }
  }
};
</script>

<style scoped>
.col-3 a {
  cursor: pointer;
}
.main {
  position: relative;
  height: 180px;
  padding: 30px;
}
.container {
  width: 100%;
}

.btn-bar {
  position: absolute;
  width: 100%;
  top: 150px;
}

.notification-icon {
  /*margin-top: 13px;*/
  margin-left: 10px;
  word-break: break-all;
}
.notification-icon img {
  margin-top: 5px;
}
.floating-wrapper {
  position: relative;
  text-align: center;
  font-size: 15px;
}
.assignment-dropdown-menu {
  position: absolute;
  z-index: 10001;
  bottom: 30px;
  left: 8px;
  border: solid 1px #90a4ae;
  height: auto;
  max-height: 120px;
  overflow-x: hidden;
  border-radius: 0;
  background: white;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.buttons {
  margin-top: 30px;
}

.button-all {
  margin-top: 30px;
  margin-right: -50px;
}

.button-div {
  display: flex;
  width: 300px;
}

p {
  float: right;
  display: inline-block;
  width: auto;
}

img {
  /*float: left;*/
  display: inline-block;
  /*margin-right: 30px;*/
  /*margin-left: 10px;*/
  /*margin-top: -10px;*/
}
.welcome-message {
  position: absolute;
  top: 160px;
  left: 0;
  font-family: "Montserrat", Montserrat, serif;
  font-size: 13.5px;
  margin-left: 15px;
}
.welcome-message-small {
  position: absolute;
  top: 125px;
  left: 13px;
  font-family: "Montserrat", Montserrat, serif;
  font-size: 13.5px;
  justify-content: start;
}
.newWidthForUserPic {
  margin-left: -13px;
  margin-top: -10px;
  width: 50%;
  height: 50%;
}
.toBigForAgent {
  position: absolute;
  top: 2px;
  left: 13px;
  font-family: "Montserrat", Montserrat, serif;
  font-size: 13.5px;
  justify-content: start;
}
.crm-message {
  margin-top: 15px;
  font-family: "Montserrat", Montserrat, serif;
  font-size: 15px;
  position: absolute;
}
.country-time {
  float: right;
  font-size: 15px;
}

.country-flag {
  margin-top: 3px;
  margin-right: 5px;
}
.viki-msg {
  font-size: 15px;
  color: red;
}
.add-tag-menu-item-title {
  margin: 5px;
  font-size: 15px;
  font-weight: bold;
}
.assign-menu-item {
  margin: 5px;
  font-size: 15px;
  font-family: "Montserrat", Montserrat, serif;
}

.assign-menu-item:hover {
  background: #e0e0e0;
  cursor: pointer;
}
ul {
  list-style: none;
  padding-left: 0;
}

.notifications-list {
  position: absolute;
  width: 720px;
  right: 40px;
  top: 10px;
  /*background-color: #0fb97b;*/
  height: auto;
  max-height: 110px;
  overflow-x: hidden;
  z-index: 10000;
  border: solid 1px #ccc;
  background-color: #fff;
  /*  -webkit-box-shadow: 4px 4px 11px -4px rgba(0,0,0,0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0,0,0,0.75);
  box-shadow: 4px 4px 11px -4px rgba(0,0,0,0.75);*/
}
.msg-datetime {
  width: 100px;
  font-size: 15px;
}
.msg-center {
  position: absolute;
  width: 720px;
  right: 40px;
  top: 10px;
  /*background-color: #0fb97b;*/

  z-index: 10000;
  border: solid 1px #ccc;
  background-color: #fff;
}

.msg-center-overflow {
  height: auto;

  max-height: 80px;
  overflow-x: hidden;
}
.btn-msg-send {
  background-color: #448aff;
  color: #ffffff;
  font-size: 15px;
  height: 30px;
}
.btn-approved {
  background-color: #efefef;
  color: black;
  height: 30px;
  font-size: 15px;
  line-height: 10px;
  margin-right: 10px;
  margin-left: 7px;
}

.btn-decline {
  background-color: #ff6666;
  color: #ffffff;
  height: 30px;
  font-size: 15px;
  line-height: 10px;
}
.btn-decline-long {
  background-color: #ff6666;
  color: #ffffff;
  height: 30px;
  font-size: 15px;
  line-height: 10px;

  position: absolute;
}
.btn-decline-long-coming-call {
  background-color: #1565c0;
  color: #ffffff;
  height: 30px;
  font-size: 15px;
  line-height: 10px;
  position: absolute;
}
.btn-all {
  background-color: #1565c0;
  color: #ffffff;
  position: absolute;
  height: 30px;
  font-size: 15px;
  line-height: 10px;
  left: 570px;
}
.btn-center {
  background-color: #1565c0;
  color: #ffffff;
  position: absolute;
  height: 30px;
  font-size: 15px;
  line-height: 10px;
  left: 430px;
}
.input-standard {
  width: 100%;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 10px;
  border-radius: 5px;
  border-style: solid;
  border-color: #90a4ae;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 15px;
  box-sizing: border-box;
}
input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: searchfield-cancel-button;
}
input[type="text"],
textarea {
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  outline: none;
  /*  padding: 3px 0px 3px 3px;
  margin: 5px 1px 3px 0px;*/
  border: 1px solid #dddddd;
}

input[type="search"]:focus,
textarea:focus {
  box-shadow: 0 0 5px rgba(81, 203, 238, 1);
  /*padding: 3px 0px 3px 3px;*/

  border: 1px solid rgba(81, 203, 238, 1);
}
.input-msg-div {
  display: flex;
}
.client-id-msg {
  color: #1144bc !important;
  cursor: pointer;
  position: absolute;
  top: 142px;
  left: 124px;
}
.client-id {
  cursor: pointer;
}
.spinner-noti-box {
  position: absolute;
  left: 300px;
  bottom: 2px;
}

.w50 {
  width: calc(45%);
  padding-top: 12px;
  padding-right: 12px;
  padding-left: 12px;
}
.right {
  float: right;
}
.margin {
  /*margin: 0.5rem;*/
}
.margin_l_hf {
  /*margin-left: 0.2rem;*/
}
.margin_r_c {
  /*margin-right: 0;*/
}
.styleCard {
  min-height: 100%;
  overflow: hidden;
  height: 200px;
  font-family: "Montserrat", Montserrat, serif;
  position: relative;
  padding-right: 12px;
  display: flex;
  flex-direction: row-reverse;
}
.styleCardContent {
  background: white;
  min-height: 12rem;
  height: 100%;
}
.sysChat {
  display: flex;
  flex-wrap: wrap;
}
.padding {
  padding: 0rem 5px 5px 5px;
}
.ai-avatar {
  flex: 1;
  min-width: 17.5%;
  border: 1px solid black;
}
.ai-avatar img {
  border-radius: 5px;
  max-width: 100%;
}
.ai-avatar-img {
  width: 180px;
  height: 197px;
  overflow: hidden;
  position: relative;
  margin: auto;
  border-radius: 5px;
}
.sysChatContent {
  flex: 8;
  /*border: 1px solid #ebeff2;*/
  border-radius: 5px 5px 0 0;
  /*margin-left: 1rem;*/
  /*padding-left: 5px;*/
  position: relative;
  height: 80%;
  font-family: "Montserrat", Montserrat, serif;
  font-size: 15px !important;
  max-width: 80%;
}
.sysChatContentTemp {
  flex: 8;
  /*border: 1px solid #ebeff2;*/
  border-radius: 5px 5px 0 0;
  /*margin-left: 1rem;*/
  /*padding-left: 5px;*/
  position: relative;
  height: 100%;
  font-family: "Montserrat", Montserrat, serif;
  font-size: 15px !important;
  max-width: 100%;
  /*padding-top: 12px;*/
  padding-right: 1px;
  /*padding-bottom: 12px;*/
  /*padding-left: 12px;*/
}
.sysChatActions {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid #ebeff2;
}

.sysChatActions input {
  width: calc(100% - 80px);
  padding: 0.7rem;
  border: 0;
}
.sysChatText {
  height: calc(100% - 3.5rem);
  overflow-y: scroll;
  padding: 0.5rem;
}
.sysChatText-notification {
  height: 100%;
  overflow-y: scroll;
  padding: 0.5rem;
}
.sysChatActions input {
  width: calc(100% - 80px);
  padding: 0.7rem;
  border: 0;
}
.sysChatActions button:hover img {
  transform: translateX(10px);
}
.sysChatActions button img {
  transition: transform 0.3s ease;
}
.sysChatActions button {
  width: 75px;
  background: none;
  border: 0;
  position: absolute;
  top: 0.1rem;
  right: 0;
  text-align: center;
  cursor: pointer;
  height: 37px;
}
.bttn {
  width: max-content;
  margin-top: 0.5rem;
  margin-left: 0.5rem;
  background: #efefef !important;
  color: #000000;
  border: 0;
  border-radius: inherit;
  padding: 5px;
  font-size: 12px;
  font-family: "Montserrat" !important;
  cursor: pointer;
  height: 28px;
}
.bttn:focus {
  outline: none !important;
}
.notifi-table {
  width: 690px !important;
  font-size: 15px;
}
.empty-div {
  width: 100%;
}
/*.button-box {*/
/*  position: absolute;*/
/*  display: -webkit-box;*/
/*  display: -ms-flexbox;*/
/*  display: flex;*/
/*  justify-content: space-evenly;*/
/*  bottom: 0rem;*/
/*  right: 20%;*/
/*  max-width: -webkit-fit-content;*/
/*  max-width: -moz-fit-content;*/
/*  max-width: fit-content;*/
/*  min-width: 66%;*/
/*  flex-direction: column;*/
/*  top: 150px;*/
/*}*/
/*.button-box .bttn {*/
/*  font-size: 8px !important;*/
/*  height: unset !important;*/
/*}*/
.date-time-div {
  /*font-weight: bold;*/
  font-size: 15px;
  float: right;
  margin-right: 234px;
  margin-top: 11px;
  color: #000;
}
.buttons-area {
  padding-left: 9px !important;
}
.buttons-area button {
  color: #bf3dff;
  border: 1px solid black;
  position: absolute;
  border-radius: 0px !important;
  text-transform: uppercase;
  font-size: 13px;
  background: white;
  top: 24px;
  height: 26px;
  border-radius: 5px !important;
  left: -86px;
}
.country-img {
  width: 40px;
  position: absolute;
  top: 140px;
  left: 87px;
}
.viki-stats-chart {
  height: 80%;
}
.test {
  /*width: 158px;*/
  /*height: 158px;*/
  /*top: 35px;*/
  /*right: 5px;*/
  /*position: absolute;*/
  width: 62px;
  height: 71px;
  top: 1px;
  left: 84px;
  position: absolute;
}

.test-agent {
  width: 62px;
  height: 71px;
  top: 10px;
  left: 84px;
  position: absolute;
}
.special {
  margin-left: 0;
}
span.vue-typer {
  cursor: default;
  -webkit-user-select: none;
  -moz-user-select: none;
  /* margin-top: 100px; */
  position: absolute;
  top: 100px;
  left: 10px;
  user-select: none;
}
span.vue-typer-agent {
  cursor: default;
  -webkit-user-select: none;
  -moz-user-select: none;
  /* margin-top: 100px; */
  position: absolute;
  top: 125px;
  left: 30px;
  user-select: none;
}
.forBorder {
  border-bottom: 1px solid;
  width: 157px;
  padding-left: -32px;
  margin-right: -28px;
  padding-right: -34px;
  margin-left: -143px;
  padding-top: 16px;
  top: 167px;
  left: 0;
}
.rootWindow {
  -webkit-transition-property: height, width;
  -webkit-transition-duration: 1s;
  -moz-transition-property: height, width;
  -moz-transition-duration: 1s;
  transition-property: height, width;
  transition-duration: 1s;
  width: 100%;
  height: 100%;
}
.rootWindowTooBig {
  margin-left: 20%;
  width: 70%;
  height: 50%;
}
/*.toBigForAgent {*/
/*  margin-left: 15px;*/
/*  margin-top: 10px;*/
/*  width: 50%;*/
/*  height: 50%;*/
/*}*/
/*.img-welcome {*/
/*  margin-top: 8px;*/
/*  height: 100%;*/
/*  width: 100%;*/
/*}*/
/*.img-after-welcome {*/
/*  height: 100%;*/
/*  width: 100%;*/
/*}*/
/*.loader-viki {*/
/*  position: absolute;*/
/*  top: 35%;*/
/*  left: 45%;*/
/*}*/
/*.rowForVickiAndPic {*/
/*  display: flex;*/
/*  flex-direction: row;*/
/*}*/
.menu-wrapper {
  /*overflow-x: visible;*/
  /*display: flex;*/
  /*justify-content: space-between;*/
  /*flex-direction: column;*/
  /*border: 1px solid black;*/
  z-index: 0;
  float: right;
  position: relative;
  /*top: 5px;*/
}
.sub-menu-dropup {
  left: -9px;
  bottom: 22px;
  /* z-index: 1000; */
  /* display: none; */
  /* float: left; */
  min-width: 115px;
  border-radius: 0px;
  padding: 0px;
  max-height: 160px;
  min-height: 160px;
  text-transform: uppercase;
}
.dropdown-item {
  height: 35px;
  min-height: 8%;
  /*padding: 1px 0px;*/
  /*margin: 0px;*/
  border-radius: 0px;
  outline: none;
  font-size: 12px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  text-align: left;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  border-radius: 5px 0px 0px 5px;
  //margin-bottom: 1px;
  background-color: white;
  border: 1px solid #e5e4e4;
  position: relative;
  z-index: 1;
}
.dropdown-item:focus {
  outline: none;
}
.dropdown-item:hover {
  transform: translateX(-7px);
  border-radius: 5px 0px 0px 5px;
  /*
  border-radius: 0px 5px 5px 0px;
*/
}
li.active {
  background-color: #c12fff;
  color: #fff;
}
span.tabName {
  padding-left: 10px;
}
.top-left {
  /*padding: 12px;*/
  border-radius: 12px;
  padding-top: 12px;
  /*padding-right: 12px;*/
  padding-left: 12px;
}
</style>
